import { useEffect, useState } from "react";
import "./snappPayPayment.css";
import { editBasket, ShippingAmount } from "../../axios";
import { toast } from "react-toastify";

const SnappPayPayment = () => {
  const [loading, setLoading] = useState(false);
  const [shippingData, setShippingData] = useState({});
  const [fourMaheAmount, setFourMaheAmount] = useState("");

  const queryParams = new URLSearchParams(location.search);
  const amount = queryParams.get("amount");
  const basketId = queryParams.get("id");

  const handlePayment = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (!amount || !basketId) {
      setLoading(false);
      return toast.error("اطلاعات سبد خرید دریافت نشد");
    }

    const editedAmount = fourMaheAmount;

    try {
      const { data } = await editBasket(basketId, editedAmount);

      if (data === "1") {
        setLoading(false);

        window.open(
          `https://atropine.ir/SnappPay/Payment.aspx?basketid=${basketId}&amount=${editedAmount}`,
          "_self",
          "noopener,noreferrer,resizable",
        );
      } else {
        setLoading(false);
        return toast.error("ادیت سبد با خطا مواجه شد");
      }
    } catch (error) {
      setLoading(false);
      return toast.error("خطا در برقراری ارتباط با سرور");
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      const { data } = await ShippingAmount();

      if (data) {
        setShippingData(data[0]);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (amount && Number(amount) > 0) {
      const amount4mahePercentage =
        Number(shippingData?.SnappPay4Mahe) -
        Number(shippingData?.Atropine4MaheSnappPay);

      const amount4mahe =
        Number(amount) + (Number(amount) / 100) * amount4mahePercentage;

      setFourMaheAmount(amount4mahe);
    }
  }, [amount, shippingData]);

  return (
    <div className="snappPay-payment">
      <div className="container">
        <div className="row gap-5 align-items-center justify-content-center">
          <div className="col-12 pb-4">
            <p className="fw-bold head-text">
              کاربر گرامی لطفا جهت پرداخت از طریق اسنپ پی، پس از تایید اطلاعات
              زیر روی دکمه ادامه پرداخت کلیک نمایید و بعد از ورود به درگاه
              اسنپ‌پی نیز گزینه پرداخت ۴ قسطه را انتخاب کنید.
            </p>
          </div>

          {shippingData ? (
            <>
              <div
                className="col-12 col-md-8 pMethod-box activeBox"
                style={{ cursor: "default" }}
              >
                <div className="box-header">
                  <h5 className="fw-bold">
                    پرداخت با <span>اعتبار ۴ قسطه</span>
                  </h5>

                  <p>
                    کارمزد اسنپ‌پی در این حالت{" "}
                    <span>{shippingData?.SnappPay4Mahe}%</span> است
                    {Number(shippingData?.Atropine4MaheSnappPay) > 0 ? (
                      <p>
                        و از این میزان
                        <span> {shippingData?.Atropine4MaheSnappPay}% </span>
                        را آتروپین به عهده گرفته است.
                      </p>
                    ) : null}
                  </p>
                </div>

                <div className="box-footer">
                  قیمت نهایی قابل پرداخت با اسنپ پی{" "}
                  {Number(fourMaheAmount).toLocaleString()} ریال
                </div>
              </div>

              <div className="col-12">
                {loading ? (
                  <div
                    className="loader-6 centerLoader"
                    style={{ width: "90%" }}
                  >
                    <span></span>
                  </div>
                ) : (
                  <button onClick={handlePayment}>ادامه پرداخت</button>
                )}
              </div>
            </>
          ) : (
            <p className="text-danger">دیتا از سمت سرور دریافت نشد!</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default SnappPayPayment;
